import * as z from "zod";

export const verifyMailbox = {
  name: "verifyMailbox" as const,
  input: z.object({ token: z.string() }),
  output: z.literal(true),
};
